<template>
    <modal
    name="modalFileupload"
    height="auto"
    width="28%"
    class="customSurveyModal"
    :scrollable="true"
    @before-open="beforeOpen"
    @closed="closed">

      <div class="row7">
        <header class="modalHeader flex flexAlignS headUnderBar">
          <div class="title">
            <p>이미지 등록</p>
          </div>
          <button @click="onClickCancel"></button>
        </header>
      </div>

      <div class="fileUploadBox">
        <div class="fileUploadImgBox mainImgBox">
          <div class="title">대표 이미지</div>
          <div class="fileUploadInputBox">
            <input type="text" v-model="fileName0" disabled>
            <input type="file" id="file0" @change="setFileName($event, '0')">
            <label for="file0">업로드</label>
            <button @click="resetFile('0')">삭제</button>
          </div>
        </div>

        <div class="fileUploadImgBox subImgBox">
          <div class="title">추가 이미지</div>
          <div class="fileUploadInputBox">
            <input type="text" v-model="fileName1" disabled>
            <input type="file" id="file1" @change="setFileName($event, '1')">
            <label for="file1">업로드</label>
            <button @click="resetFile('1')">삭제</button>
          </div>
          <div class="fileUploadInputBox">
            <input type="text" v-model="fileName2" disabled>
            <input type="file" id="file2" @change="setFileName($event, '2')">
            <label for="file2">업로드</label>
            <button @click="resetFile('2')">삭제</button>
          </div>
          <div class="fileUploadInputBox">
            <input type="text" v-model="fileName3" disabled>
            <input type="file" id="file3" @change="setFileName($event, '3')">
            <label for="file3">업로드</label>
            <button @click="resetFile('3')">삭제</button>
          </div>
          <div class="fileUploadInputBox">
            <input type="text" v-model="fileName4" disabled>
            <input type="file" id="file4" @change="setFileName($event, '4')">
            <label for="file4">업로드</label>
            <button @click="resetFile('4')">삭제</button>
          </div>
          <div class="fileUploadInputBox">
            <input type="text" v-model="fileName5" disabled>
            <input type="file" id="file5" @change="setFileName($event, '5')">
            <label for="file5">업로드</label>
            <button @click="resetFile('5')">삭제</button>
          </div>
        </div>
      </div>
      
      <div class="modalFooterBtn btnBox">
        <button class="redBtn" @click="onClickSave">등 록</button>
        <button class="redborderBtn" @click="onClickCancel">취 소</button>
      </div>
      
    </modal>
</template>

<script>
export default {
  name: 'ModalFileUpload',
  props:[
    'saveData'
  ],
  components: {
  },
  data(){
    return{
      modalResult: false,
      tempFile0 : null,
      tempFile1 : null,
      tempFile2 : null,
      tempFile3 : null,
      tempFile4 : null,
      tempFile5 : null,
      fileName0 : '',
      fileName1 : '',
      fileName2 : '',
      fileName3 : '',
      fileName4 : '',
      fileName5 : ''
    }
  },
  computed:{
  },
  mounted(){
    this.show();

    if(this.saveData.file0){
      this.fileName0 = this.saveData.file0.name;
      this.tempFile0 = this.saveData.file0;
    } else if(this.saveData.saveFileName0 && !this.saveData.deleteFileList.includes(0)){
      this.fileName0 = this.saveData.saveFileName0;
    }

    if(this.saveData.file1){
      this.fileName1 = this.saveData.file1.name;
      this.tempFile1 = this.saveData.file1;
    } else if(this.saveData.saveFileName1 && !this.saveData.deleteFileList.includes(1)){
      this.fileName1 = this.saveData.saveFileName1;
    }

    if(this.saveData.file2){
      this.fileName2 = this.saveData.file2.name;
      this.tempFile2 = this.saveData.file2;
    } else if(this.saveData.saveFileName2 && !this.saveData.deleteFileList.includes(2)){
      this.fileName2 = this.saveData.saveFileName2;
    }

    if(this.saveData.file3){
      this.fileName3 = this.saveData.file3.name;
      this.tempFile3 = this.saveData.file3;
    } else if(this.saveData.saveFileName3 && !this.saveData.deleteFileList.includes(3)){
      this.fileName3 = this.saveData.saveFileName3;
    }

    if(this.saveData.file4){
      this.fileName4 = this.saveData.file4.name;
      this.tempFile4 = this.saveData.file4;
    } else if(this.saveData.saveFileName4 && !this.saveData.deleteFileList.includes(4)){
      this.fileName4 = this.saveData.saveFileName4;
    }

    if(this.saveData.file5){
      this.fileName5 = this.saveData.file5.name;
      this.tempFile5 = this.saveData.file5;
    } else if(this.saveData.saveFileName5  && !this.saveData.deleteFileList.includes(5)){
      this.fileName5 = this.saveData.saveFileName5;
    }
  },
  methods:{
    show(){
      this.$modal.show('modalFileupload')
    },
    hide(){
      this.$modal.hide('modalFileupload')
    },
    beforeOpen(){
    },
    closed(){
      this.$emit('modal-closed', this.$options.name, {result: this.modalResult})
    },
    init(){
    },
    onClickSave(){
      this.$emit('set-file', this.tempFile0, this.tempFile1, this.tempFile2, this.tempFile3, this.tempFile4, this.tempFile5);
      this.hide();
    },
    onClickCancel(){
      this.hide()
    },
    resetFile(num){
      if(num == '0'){
        if(this.tempFile0){
          this.tempFile0 = null;
        }

        if(this.saveData.saveFileName0 && this.saveData.deleteFileList.indexOf(0) < 0){
          this.saveData.deleteFileList.push(0);
        }

        this.fileName0 = '';
      } else if(num == '1'){
        if(this.tempFile1){
          this.tempFile1 = null;
        }

        if(this.saveData.saveFileName1 && this.saveData.deleteFileList.indexOf(1) < 0){
          this.saveData.deleteFileList.push(1);
        }

        this.fileName1 = '';
        
      } else if(num == '2'){
        if(this.tempFile2){
          this.tempFile2 = null;
        }

        if(this.saveData.saveFileName2 && this.saveData.deleteFileList.indexOf(2) < 0){
          this.saveData.deleteFileList.push(2);
        }
        this.fileName2 = '';
      } else if(num == '3'){
        if(this.tempFile3){
          this.tempFile3 = null;
        }
        if(this.saveData.saveFileName3 && this.saveData.deleteFileList.indexOf(3) < 0){
          this.saveData.deleteFileList.push(3);
        }
        this.fileName3 = '';
      } else if(num == '4'){
        if(this.tempFile4){
          this.tempFile4 = null;
        }
        if(this.saveData.saveFileName4 && this.saveData.deleteFileList.indexOf(4) < 0){
          this.saveData.deleteFileList.push(4);
        }
        this.fileName4 = '';
      } else if(num == '5'){
        if(this.tempFile5){
          this.tempFile5 = null;
        }

        if(this.saveData.saveFileName5 && this.saveData.deleteFileList.indexOf(5) < 0){
          this.saveData.deleteFileList.push(5);
        }
        this.fileName5 = '';
      }

      console.log(this.saveData.deleteFileList)
    },
    setFileName(event, num){
      let fileName = event.target.files[0].name;
            
      let fileNameArr = fileName.split(".");
      let ext = fileNameArr[fileNameArr.length-1];

      let checkExts = ['gif', 'png', 'jpg', 'jpeg','GIF', 'PNG', 'JPG', 'JPEG'];

      var check = checkExts.some(function(checkExt) {
          return ext === checkExt;
      });

      if(!check){
          this.$alert("알림", "업로드가 불가한 확장자입니다. <br>(gif, png, jpg, jpeg 파일만 업로드할 수 있습니다.)");
          return;
      }

      var maxSize  = 10*1024*1000;
      if(event.target.files[0].size > maxSize){
          this.$alert("알림", "첨부파일은 10mb이하의 크기만 업로드 가능합니다.");
          return;
      }
      
      if(num == '0'){
        this.tempFile0 = event.target.files[0];
        this.fileName0 = fileName;
      } else if(num == '1'){
        this.tempFile1 = event.target.files[0];
        this.fileName1 = fileName;
      } else if(num == '2'){
        this.tempFile2 = event.target.files[0];
        this.fileName2 = fileName;
      } else if(num == '3'){
        this.tempFile3 = event.target.files[0];
        this.fileName3 = fileName;
      } else if(num == '4'){
        this.tempFile4 = event.target.files[0];
        this.fileName4 = fileName;
      } else if(num == '5'){
        this.tempFile5 = event.target.files[0];
        this.fileName5 = fileName;
      } 

      if(this.saveData.deleteFileList.includes(Number(num))){
        var index = this.saveData.deleteFileList.indexOf(Number(num));
        this.saveData.deleteFileList.splice(index, 1);
      }
    }
  }
}
</script>